/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * OBJECTS
 */
const Index = gql`
  query VendorAccountOptionsQuery($take: PositiveInt!, $skip: Int!, $search: String) {
    VendorAccountOptions(take: $take, skip: $skip, vendorAccountNameToSearch: $search) {
      id
      displayName
    }
  }
`


/*
 * EXPORTS
 */
export default Index
